import c from 'classnames';
import { twMerge } from 'tailwind-merge';

export const mergeTailwindClasses = (...classes: string[]) => {
  return twMerge(c(...classes));
};

// Export as default for compatibility with imports like: import c from '.../tailwind-merge'
export default mergeTailwindClasses;
// Also allow: import { mergeTailwindClasses as c } from '.../tailwind-merge'
export { mergeTailwindClasses as c };
